module.exports = __webpack_public_path__ + "static/assetsMobileBox-11a07ef3ea089088381e9dbda8c2c351.png";